export const RESOURCE_TYPE = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
export const RESOURCE_KEY = 'recommendations-fetch-traits-resource-key';
export const ANALYTICS_ID = 'useResource.fetchRecommendationsUserTraits';
